module.exports = "<span ng-datepicker\n      default-date=\"initialDateV\"\n      start-view=\"year\"\n      min-view=\"day\"\n      input-id=\"localDateChooser\"\n      name=\"localDateChooser\"\n      max-date=\"maxDateV\"\n      ng-model=\"value\"></span>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/time/templates/local-date-chooser.html
 ** module id = 740
 ** module chunks = 0
 **/